<template>
  <div class="w-100 d-flex-wrap">
    <label v-for="(item, index) in radioList" :key="index" :class="`width-${item.width}`">
      <input type="radio" :value="item.value" v-model="picked" style="display: none" :disabled="disabled" />
      <cus-button
        color="gray-noFocus"
        :text="item.label"
        :selected="picked === item.value ? true : false"
        :disabled="disabled"
      ></cus-button>
    </label>
  </div>
</template>
<script>
export default {
  name: 'button-radio',
  props: {
    radioList: { type: Array },
    fontSize: { type: String },
    selectValue: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    picked: {
      get() {
        return this.selectValue;
      },
      set(val) {
        this.$emit('update:selectValue', val);
      },
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
:deep(.button-selected) {
  @include button-set(#fff, $color-blue, transparent);
  &:active {
    @include button-set(#fff, $color-blue, transparent);
  }
}
</style>
